import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MarketTicker from './MarketTicker'; 

import '../css/navbar.css';

/* FIX #18 — Responsive SVG logo: uses viewBox + CSS width/height so it
   scales down on small screens without clipping or overflowing. */
const LogoSVG = () => (
  <svg
    viewBox="0 0 760 243"
    width="220"
    height="70"
  >
    <image
      href="/Logo1.png"
      x="0"
      y="0"
      width="760"
      height="243"
      preserveAspectRatio="xMinYMid meet"
    />
  </svg>

);

export default function Navbar() {
  const [stuck, setStuck] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dropOpen, setDropOpen] = useState(false);
  const [mobDropOpen, setMobDropOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll when drawer is open
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  // Close drawer on route change
  useEffect(() => { setDrawerOpen(false); setDropOpen(false); }, [location]);

  // Close drawer on ESC
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setDrawerOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const isActive = (path) => location.pathname === path ? 'nav-active' : '';

  const topics = [
    // { label: 'Leadership', href: '/topics/leadership' },
    // { label: 'Longreads', href: '/topics/longreads' },
    // { label: 'Press Release', href: '/category/press-release' },
    { label: 'Healthcare', href: '/topics/healthcare' },
    { label: 'Retail', href: '/topics/retail' },
    { label: 'Artificial Intelligence', href: '/topics/artificial-intelligence' },
    { label: 'IT Services', href: '/topics/it-services' },
    { label: 'Banking & Finance', href: '/topics/banking-finance' },
    { label: 'Legal', href: '/topics/legal' },
    { label: 'Digital Marketing', href: '/topics/digital-marketing' },
    { label: 'Startup', href: '/topics/startup' },
    { label: 'IoT', href: '/topics/iot' },
    { label: 'Mining & Metals', href: '/topics/mining-metals' },
  ];

  return (
    <>
      <MarketTicker />
      <header
        className={`site-header${stuck ? ' stuck' : ''}`}
        id="site-header"
        role="banner"
      >
        <div className="header-inner">
          <Link to="/" className="logo-wrap" aria-label="Home">
            <LogoSVG />
          </Link>

          {/* Desktop nav */}
          <nav className="main-nav" aria-label="Primary navigation">
            <ul>
              <li><Link to="/" className={isActive('/')}>Home</Link></li>
              <li><Link to="/magazine" className={isActive('/magazine')}>Magazine</Link></li>
              <li>
                <Link
                  to="/women-in-business"
                  className={isActive('/women-in-business')}
                >
                  Women in Business
                </Link>
              </li>

              {/* <li>
                <Link to="/about" className={isActive('/about')}>
                  About
                </Link>
              </li>  */}
              {/* this new */}
              <li
                className="has-drop"
                onMouseEnter={() => setDropOpen(true)}
                onMouseLeave={() => setDropOpen(false)}
              >
                <button
                  aria-expanded={dropOpen}
                  aria-haspopup="true"
                  style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    color: dropOpen ? 'var(--gold)' : 'var(--white70)',
                    font: 'inherit', padding: '7px 10px',
                    fontSize: '.78rem', fontWeight: 500,
                    letterSpacing: '.04em', textTransform: 'uppercase',
                    transition: 'color var(--dur)',
                  }}
                >
                  Topics <span className="nav-arrow">&#9662;</span>
                </button>
                {dropOpen && (
                  <ul className="drop-menu" role="menu">
                    {topics.map(t => (
                      <li key={t.label} role="none">
                        <Link to={t.href} role="menuitem">{t.label}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              <li>
                <Link
                  to="/blogs"
                  className={isActive('/blogs')}
                >
                  Blogs
                </Link>
              </li>
              <li>
                <Link
                  to="/category/press-release"
                  className={isActive('/category/press-release')}
                >
                  Press Release
                </Link>
              </li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/advertise">Advertise</Link></li>
              {/* <li><Link to="/contact">Contact</Link></li> */}
            </ul>
          </nav>

          <Link to="/#subscribe" className="btn-sub">
            Subscribe Us
          </Link>

          {/* Hamburger */}
          <button
            className={`burger${drawerOpen ? ' open' : ''}`}
            onClick={() => setDrawerOpen(o => !o)}
            aria-label={drawerOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={drawerOpen}
            aria-controls="mobile-drawer"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </button>
        </div>
      </header>

      {/* Mobile overlay */}
      <div
        className={`mob-overlay${drawerOpen ? ' show' : ''}`}
        onClick={() => setDrawerOpen(false)}
        aria-hidden="true"
      />

      {/* Mobile drawer */}
      <aside
        id="mobile-drawer"
        className={`mob-drawer${drawerOpen ? ' show' : ''}`}
        aria-hidden={!drawerOpen}
        aria-label="Mobile navigation"
      >
        <button
          className="mob-close"
          onClick={() => setDrawerOpen(false)}
          aria-label="Close menu"
        >
          &#10005;
        </button>

        <div className="mob-logo">
          <img
            src="/Logo1.png"
            alt="The Elite Global Review"
            className="footer-logo"
            width="180"
            height="30"
          />
        </div>

        <nav aria-label="Mobile navigation">
          <ul className="mob-links">
            <li><Link to="/" onClick={() => setDrawerOpen(false)}>Home</Link></li>
            <li><Link to="/magazine" onClick={() => setDrawerOpen(false)}>Magazine</Link></li>
            <li><Link to="/women-in-business" onClick={() => setDrawerOpen(false)}>Women In Business</Link></li>

            <li className="mob-has-drop">
              <button
                className={`mob-drop-btn${mobDropOpen ? ' open' : ''}`}
                onClick={() => setMobDropOpen(o => !o)}
                aria-expanded={mobDropOpen}
              >
                Topics <span className="mob-arrow">&#9662;</span>
              </button>
              <ul className={`mob-drop${mobDropOpen ? ' show' : ''}`}>
                {topics.map(t => (
                  <li key={t.label}>
                    <Link to={t.href} onClick={() => setDrawerOpen(false)}>{t.label}</Link>
                  </li>
                ))}
              </ul>
            </li>
            <li><Link to="/blogs" onClick={() => setDrawerOpen(false)}>Blogs</Link></li>
            <li><Link to="/category/press-release" onClick={() => setDrawerOpen(false)}>Press Releases</Link></li>
            <li><Link to="/about" onClick={() => setDrawerOpen(false)}>About</Link></li>
            <li><Link to="/advertise" onClick={() => setDrawerOpen(false)}>Advertise</Link></li>
            {/* <li><Link to="/contact" onClick={() => setDrawerOpen(false)}>Contact</Link></li> */}
          </ul>
        </nav>

        <Link
          to="/#subscribe"
          className="mob-sub-btn"
          onClick={() => setDrawerOpen(false)}
        >
          Subscribe Us
        </Link>
      </aside>
    </>
  );
}